"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Search_vue_1 = __importDefault(require("../../../Common/Search.vue"));
const HeadTable_vue_1 = __importDefault(require("../../../Common/HeadTable.vue"));
const Proposal_vue_1 = __importDefault(require("../components/Proposal.vue"));
const ZeroView_vue_1 = __importDefault(require("@becrop/components/Common/ZeroView.vue"));
const QuickFilter_vue_1 = __importDefault(require("@becrop/components/Common/QuickFilter.vue"));
const ModalStamp_vue_1 = __importDefault(require("@becrop/components/Common/ModalStamp.vue"));
const trans_1 = require("@common/tsutils/trans");
const axios_1 = __importDefault(require("axios"));
let AreaSelection = class AreaSelection extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.thead = [
            (0, trans_1.trans)('gisUploader.thead.Proposal'),
            (0, trans_1.trans)('gisUploader.thead.Project'),
            (0, trans_1.trans)('gisUploader.thead.Area'),
            (0, trans_1.trans)('gisUploader.thead.Extension'),
            (0, trans_1.trans)('gisUploader.thead.Crop'),
            (0, trans_1.trans)('gisUploader.thead.Status'),
            (0, trans_1.trans)('gisUploader.thead.Actions'),
        ];
        this.proposals = [];
        this.textSearch = '';
        this.arrOrderProposal = [];
        this.filteredProposals = [];
        this.arrLocations = [];
        this.unicosLocations = [];
        this.orderNumber = 0;
        this.filterActive = false;
        this.modalCopyConfig = false;
        this.locationCopy = {};
        this.locationPaste = {};
    }
    async getProposal() {
        try {
            await axios_1.default.get('/tracking/legacy/proposals').then((res) => {
                console.log(res);
                this.proposals = res.data;
            });
        }
        catch (error) {
            console.log(error);
        }
        this.filteredProposals = this.proposals.map(p => (Object.assign({}, p)));
    }
    actionModalContinue(value) {
        this.modalCopyConfig = value;
        this.copyConfig();
    }
    actionModalCancel(value) {
        this.modalCopyConfig = value;
        this.copyConfig();
    }
    backdropAction(value) {
        this.modalCopyConfig = value;
        this.copyConfig();
    }
    copyConfig() { }
    setView(value) {
        this.$emit('setView', value);
    }
    setLocations(value) {
        this.$emit('setLocations', value);
    }
    openModalCopyConfig(copy, paste) {
        this.modalCopyConfig = true;
        this.locationCopy = copy;
        this.locationPaste = paste;
    }
    toggleQuickPending() {
        const keyPendingString = '#pending';
        (this.textSearch === keyPendingString) ? this.textSearch = '' : this.textSearch = keyPendingString;
    }
    orderCriterial(order) {
        this.filteredProposals = this.filteredProposals.sort((a, b) => {
            if (order === 1) {
                return (a.name > b.name) ? -1 : 1;
            }
            else {
                return (a.name < b.name) ? 1 : -1;
            }
        });
    }
    filterSearch(value) {
        this.textSearch = value;
        (value.length > 0) ? this.filterActive = true : this.filterActive = false;
        function matchNameCode(item) {
            var _a, _b;
            if ((_a = item.code_name) === null || _a === void 0 ? void 0 : _a.toLowerCase().trim().includes(value.toLowerCase().trim()))
                return true;
            if ((_b = item.name) === null || _b === void 0 ? void 0 : _b.toLowerCase().trim().includes(value.toLowerCase().trim()))
                return true;
            return false;
        }
        function matchLocName(item) {
            var _a;
            if (((_a = item.area.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().trim().includes(value.toLowerCase().trim())) ||
                item.crop.name.toLowerCase().trim().includes(value.toLowerCase().trim()) ||
                item.status.includes(value.replace('#', '').toLowerCase().trim()))
                return true;
            return false;
        }
        const theFilteredProposals = this.proposals.map((proposal) => {
            if (matchNameCode(proposal)) {
                return proposal;
            }
            else {
                if (proposal.projects.some(project => matchNameCode(project))) {
                    return Object.assign(Object.assign({}, proposal), { projects: proposal.projects.filter(project => matchNameCode(project)).map(pr => pr) });
                }
                else {
                    if (proposal.projects
                        .some(project => project.gis_areas
                        .some(gis => matchLocName(gis)))) {
                        return Object.assign(Object.assign({}, proposal), { projects: proposal.projects.filter(project => project.gis_areas.some((gis) => matchLocName(gis))).map((proj) => {
                                return Object.assign(Object.assign({}, proj), { gis_areas: proj.gis_areas.filter((gisarea) => matchLocName(gisarea)) });
                            }) });
                    }
                    else {
                        return {
                            id: 0,
                            name: '',
                            code_name: '',
                            projects: []
                        };
                    }
                }
            }
        });
        this.filteredProposals = theFilteredProposals;
    }
    async motherFuction() {
        await this.getProposal();
    }
    created() {
        this.motherFuction();
    }
};
AreaSelection = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Search: Search_vue_1.default,
            HeadTable: HeadTable_vue_1.default,
            Proposal: Proposal_vue_1.default,
            ZeroView: ZeroView_vue_1.default,
            QuickFilter: QuickFilter_vue_1.default,
            ModalStamp: ModalStamp_vue_1.default,
        },
    })
], AreaSelection);
exports.default = AreaSelection;
